import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children", "sx", "value", "onChange"],
    _excluded4 = ["children", "name"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { forwardRef, useEffect, useMemo, useReducer } from 'react';
import Flex from '../Flex';
import Box from '../Box';
import { TabListContext, TabsContext } from './contexts';
export var TabPane = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    ref: ref
  }), children);
});
TabPane.displayName = 'TabPane';
export var TabPanels = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    ref: ref
  }), children({
    getAriaProps: function getAriaProps() {
      return {};
    }
  }));
});
TabPanels.displayName = 'TabPanels';

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'change':
      return action.payload;

    default:
      return state;
  }
};

export var TabList = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      sx = _ref3.sx,
      _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? '' : _ref3$value,
      onChange = _ref3.onChange,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  var _useReducer = useReducer(reducer, value),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var api = useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  useEffect(function () {
    onChange === null || onChange === void 0 ? void 0 : onChange(state);
  }, [state]);
  useEffect(function () {
    dispatch({
      type: 'change',
      payload: value
    });
  }, [value]);
  return /*#__PURE__*/React.createElement(TabListContext.Provider, {
    value: api
  }, /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, rest, {
    sx: _objectSpread({
      width: '100%',
      overflow: 'hidden'
    }, sx)
  }), /*#__PURE__*/React.createElement(Flex, {
    role: "tablist",
    sx: {
      borderBottom: function borderBottom(theme) {
        return theme.separatorBorder.normal;
      },
      width: '100%',
      alignItems: 'stretch',
      flexBasis: 'auto',
      overflowX: 'auto',
      overflowY: 'hidden',
      overscrollBehaviorY: 'none',
      scrollPadding: '0',
      scrollSnapType: 'x mandatory',
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    }
  }, children)));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
TabList.displayName = 'TabList';
export var Tabs = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
      name = _ref4.name,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: name
  }, /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    ref: ref
  }), children));
});
Tabs.displayName = 'Tabs';
export default Tabs;